import { connect } from 'react-redux';
let phrases = {};
export function translate(key) {
    if (!(key in phrases)) {
        if (process.env.NODE_ENV !== 'production') {
            console.error('Missing translation for phrase:', key);
            return key;
        }
        return '';
    }
    else {
        return format.apply(null, [phrases[key], ...Array.prototype.slice.call(arguments, 1)]);
    }
}
export function setPhrases(p) {
    phrases = p;
}
export function format(phrase) {
    if (arguments.length === 1) {
        return phrase;
    }
    else if (typeof arguments[1] === 'object' && !!arguments[1]) {
        return formatObject(phrase, arguments[1]);
    }
    else {
        return formatArray(phrase, Array.prototype.slice.call(arguments, 1));
    }
}
function formatArray(phrase, values) {
    if (!phrase) {
        return phrase;
    }
    const regex = /{(\d+)}/g;
    if (process.env.NODE_ENV !== 'production') {
        const placeholders = phrase.match(regex) || [];
        if (placeholders.length !== values.length) {
            const error = `The phrase "${phrase}" contains ${placeholders.length} placeholders
                    but ${values.length} placeholders was passed to translate(). The placeholders
                    passed in was: ${JSON.stringify(values)}`;
            throw new Error(error);
        }
    }
    return values.length === 0
        ? phrase
        : phrase.replace(regex, (match, index) => typeof values[index] !== 'undefined' ? values[index] : match);
}
export function formatObject(phrase, args) {
    if (!phrase) {
        return phrase;
    }
    return phrase.replace(/({[^}]+})/g, ph => {
        const key = ph.substr(1, ph.length - 2).trim();
        if (key in args) {
            const val = args[key];
            if (val == null) {
                return '';
            }
            else if (typeof val === 'number') {
                return val.toString();
            }
            else {
                return val;
            }
        }
        else {
            console.error('Could not find placeholder', key, 'in', args);
            return ph;
        }
    });
}
function Translate(props) {
    const { phrase, children, values, languagePhrases } = props;
    if (!(phrase in languagePhrases)) {
        if (process.env.NODE_ENV !== 'production') {
            throw new Error(`Missing translation for phrase: ${phrase}`);
        }
    }
    let result = languagePhrases[phrase];
    if (values) {
        result = values instanceof Array ? formatArray(result, values) : formatObject(result, values);
    }
    if (typeof children === 'function') {
        return children(result);
    }
    return result;
}
export default connect((state) => ({
    languagePhrases: state.appShellData.languagePhrases,
}))(Translate);
